import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  Typography,
  Popover,
} from "@mui/material";
import QuationReportTable from "../../Components/TalentPoolCard/QuesionReportTable";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useMessage } from "../../Components/snackbar/snackbar";
import SkillWisePerformance from "../../Components/TalentPoolCard/SkillWisePerformance";
import { getColorByStatus, capitalizeWords } from "../../utils";
import CheatingDetected from "../../Components/cheatingDetected/CheatingDetected";

const CandidateResults = ({ candidateAssessmentDetails }) => {
  const navigate = useNavigate();
  const message = useMessage();
  const [currentTab, setCurrentTab] = useState(0);
  const [drawerHeading, setDrawerHeading] = useState("");
  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("mcqQuestions");
  const [backgroundImage, setBackgroundImage] = useState(
    candidateAssessmentDetails?.candidateProfilePicture ||
      "/assets/avatar-fallback.svg",
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverText, setPopoverText] = useState("");

  const handlePopoverOpen = (event, text) => {
    setAnchorEl(event.currentTarget);
    setPopoverText(text);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setPopoverText("");
  };
  const open = Boolean(anchorEl);

  useEffect(() => {
    const handlePopState = () => {
      navigate(`/assessments/analytics`, {
        state: { tabValue: "candidates" },
      });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  useEffect(() => {
    const img = new Image();
    img.src = candidateAssessmentDetails?.candidateProfilePicture;
    img.onload = () => {
      setBackgroundImage(candidateAssessmentDetails?.candidateProfilePicture);
    };
    img.onerror = () => {
      setBackgroundImage("/assets/avatar-fallback.svg");
    };
  }, [candidateAssessmentDetails?.candidateProfilePicture]);

  const totalScoreAttempted = countScoreAttemptedQuestions(
    candidateAssessmentDetails?.assessmentResult?.testQuestions?.skills,
  );

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const candidate_details_profile = [
    {
      icn: "../assets/candidate_details_profile_1.svg",

      lable: "Candidate rank",

      number: `# ${
        candidateAssessmentDetails?.assessmentResult?.candidateRank || "N/A"
      }`,
    },

    {
      icn: "../assets/candidate_details_profile_2.svg",

      lable: "Candidate Score",

      number:
        candidateAssessmentDetails?.assessmentResult?.totalObtainedScores ||
        candidateAssessmentDetails?.assessmentResult?.totalObtainedScore ||
        "0",
    },
    {
      icn: "../assets/candidate_details_profile_3.svg",
      lable: "Duration (mins)",
      number: candidateAssessmentDetails?.assessmentResult?.totalTimeSpent
        ? (() => {
            const totalSeconds = Math.round(
              candidateAssessmentDetails.assessmentResult.totalTimeSpent,
            );
            const minutes = Math.floor(totalSeconds / 60);
            const secs = totalSeconds % 60;
            return `${minutes}.${secs.toString().padStart(2, "0")}`;
          })()
        : "N/A",
    },
    {
      icn: "../assets/candidate_details_profile_4.svg",
      lable: "Test Attempted",
      number: `${
        totalScoreAttempted.totalAttemptedCount &&
        candidateAssessmentDetails?.assessmentId?.totalNoOfQuestions
          ? (
              (totalScoreAttempted.totalAttemptedCount /
                candidateAssessmentDetails.assessmentId.totalNoOfQuestions) *
              100
            ).toFixed(2) + " %"
          : "N/A"
      }`,
    },
  ];

  const candidate_details_about = [
    {
      icn: (
        <Tooltip title="Email" arrow>
          <img src="/assets/candidate_details_about_1.svg" alt="Email Icon" />
        </Tooltip>
      ),
      label: candidateAssessmentDetails?.candidateId?.email || "N/A",
    },
    {
      icn: (
        <Tooltip title="Mobile" arrow>
          <img src="/assets/candidate_details_about_2.svg" alt="Mobile Icon" />
        </Tooltip>
      ),
      label: candidateAssessmentDetails?.candidateId?.mobile
        ? `+${candidateAssessmentDetails?.candidateId?.mobile.countryCode} ${candidateAssessmentDetails.candidateId.mobile.number}`
        : "N/A",
    },
    {
      icn: (
        <Tooltip title="Address" arrow>
          <img src="/assets/candidate_details_about_3.svg" alt="Address Icon" />
        </Tooltip>
      ),
      label:
        candidateAssessmentDetails?.candidateId?.additionalDetails?.address ||
        "N/A",
    },
    {
      icn: (
        <Tooltip title="College Name" arrow>
          <img src="/assets/candidate_details_about_4.svg" alt="College Icon" />
        </Tooltip>
      ),
      label: candidateAssessmentDetails?.candidateId?.collegeName || "N/A",
    },
    {
      icn: (
        <Tooltip title="City" arrow>
          <img src="/assets/candidate_details_about_5.svg" alt="Country Icon" />
        </Tooltip>
      ),
      label:
        candidateAssessmentDetails?.candidateId?.additionalDetails?.country ||
        "N/A",
    },
    {
      icn: (
        <Tooltip title="Age" arrow>
          <img src="/assets/candidate_details_about_6.svg" alt="Age Icon" />
        </Tooltip>
      ),
      label:
        candidateAssessmentDetails?.candidateId?.additionalDetails?.age !==
        undefined
          ? `${candidateAssessmentDetails.candidateId.additionalDetails.age} years`
          : "N/A",
    },
    {
      icn: (
        <Tooltip title="Portfolio Link" arrow>
          <img
            src="/assets/candidate_details_about_7.svg"
            alt="Portfolio Icon"
          />
        </Tooltip>
      ),
      label:
        candidateAssessmentDetails?.candidateId?.additionalDetails?.socialLinks?.map(
          (link) => link?.linkedin,
        ) || "N/A",
    },
    {
      icn: (
        <Tooltip title="GitHub Username" arrow>
          <img src="/assets/candidate_details_about_8.svg" alt="GitHub Icon" />
        </Tooltip>
      ),
      label:
        candidateAssessmentDetails?.candidateId?.additionalDetails?.socialLinks?.map(
          (link) => link?.github,
        ) || "N/A",
    },
  ];

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };

    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      // Return default value if date is invalid
      return "Jan 22 2022, 12:12:12 PM IST";
    }

    const formattedDate = date.toLocaleString("en-US", options);
    return `${formattedDate} IST`;
  };

  const candidate_pool_test_time_analysis = [
    {
      lable: "Invited At",
      time: formatDate(
        candidateAssessmentDetails?.assessmentResult?.invitationDetails?.sentAt,
      ),
    },
    {
      lable: "Started At",
      time: formatDate(
        candidateAssessmentDetails?.assessmentResult?.testStartedOn,
      ),
    },
    {
      lable: "Ended At",
      time: formatDate(
        candidateAssessmentDetails?.assessmentResult?.testSubmittedOn,
      ),
    },
    {
      lable: "Test Duration",
      time: `${
        candidateAssessmentDetails?.assessmentResult?.totalTimeSpent
          ? (() => {
              const totalSeconds = Math.round(
                candidateAssessmentDetails.assessmentResult.totalTimeSpent,
              );
              const minutes = Math.floor(totalSeconds / 60);
              const secs = totalSeconds % 60;
              return `${minutes}.${secs.toString().padStart(2, "0")}`;
            })()
          : "N/A"
      } mins`,
    },
  ];

  const handleButtonClick = (label) => {
    switch (label) {
      case "Snapshots Taken":
        setCurrentTab(0);
        setDrawerHeading("View Snapshot");
        break;
      case "Tabs switched":
        setCurrentTab(1);
        setDrawerHeading("View Tabs");
        break;
      case "Plagiarism (%)":
        setCurrentTab(2);
        setDrawerHeading("View Details");
        break;
      default:
        break;
    }
    setToggleDrawer(true);
  };

  const handleDrawerToggle = () => {
    setToggleDrawer(true);
  };

  function countScoreAttemptedQuestions(skills) {
    let totalAttemptedCount = 0;
    let results = [];

    skills?.forEach((skill) => {
      const skillName = skill.name;
      let skillAttemptedCount = 0;
      let skillTotalScore = 0;

      const {
        easyQuestions: mcqEasy,
        mediumQuestions: mcqMedium,
        hardQuestions: mcqHard,
      } = skill.mcqQuestions;

      skillAttemptedCount += mcqEasy.filter(
        (question) => question.isAttempted,
      ).length;
      skillTotalScore += mcqEasy
        .filter((question) => question.isAttempted)
        .reduce((acc, question) => acc + question.score, 0);

      skillAttemptedCount += mcqMedium.filter(
        (question) => question.isAttempted,
      ).length;
      skillTotalScore += mcqMedium
        .filter((question) => question.isAttempted)
        .reduce((acc, question) => acc + question.score, 0);

      skillAttemptedCount += mcqHard.filter(
        (question) => question.isAttempted,
      ).length;
      skillTotalScore += mcqHard
        .filter((question) => question.isAttempted)
        .reduce((acc, question) => acc + question.score, 0);

      const {
        easyQuestions: progEasy,
        mediumQuestions: progMedium,
        hardQuestions: progHard,
      } = skill.programmingQuestions;

      skillAttemptedCount += progEasy.filter(
        (question) => question.isAttempted,
      ).length;
      skillTotalScore += progEasy
        .filter((question) => question.isAttempted)
        .reduce((acc, question) => acc + question.score, 0);

      skillAttemptedCount += progMedium.filter(
        (question) => question.isAttempted,
      ).length;
      skillTotalScore += progMedium
        .filter((question) => question.isAttempted)
        .reduce((acc, question) => acc + question.score, 0);

      skillAttemptedCount += progHard.filter(
        (question) => question.isAttempted,
      ).length;
      skillTotalScore += progHard
        .filter((question) => question.isAttempted)
        .reduce((acc, question) => acc + question.score, 0);

      totalAttemptedCount += skillAttemptedCount;

      results.push({
        skillName,
        skillNameAttemptedCount: skillAttemptedCount,
        skillNameTotalScore: skillTotalScore,
      });
    });

    return {
      results,
      totalAttemptedCount,
    };
  }

  return loading ? (
    "Loading..."
  ) : (
    <>
      <Box
        sx={{
          borderRadius: "4px",
          display: "flex",
          gap: "16px",
          height: "auto",
          flexDirection: { xss: "row", base: "column" },
        }}
      >
        <Box
          sx={{
            width: { xss: "50%", md: "30%" },
            height: "auto",
            backgroundColor: "#ffffff",
            position: "",
            padding: "16px",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: { md: "188px", base: "220px" },
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "top",
              borderRadius: "4px",
              overflow: "hidden",
            }}
          />
          <Box
            sx={{ padding: "16px 0px", display: "flex", alignItems: "center" }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: "18px",
                fontWeight: "700",
                fontFamily: "Nunito, sans-serif",
              }}
            >
              {candidateAssessmentDetails?.candidateId?.name}
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            {/* <Typography
              component="div"
              sx={{ display: "flex", alignItems: "center" }}
            >
              {getStatus(candidateAssessmentDetails?.currentStatus)}
            </Typography> */}
            <Stack
              direction={"row"}
              alignItems={"flex-start"}
              gap={"2px"}
              justifyContent={"center"}
              sx={{
                padding: "4px 12px",
                gap: "4px",
                backgroundColor: getColorByStatus(
                  candidateAssessmentDetails?.currentStatus === "Appeared"
                    ? candidateAssessmentDetails?.assessmentResult
                        ?.totalObtainedScore >=
                      candidateAssessmentDetails?.assessmentId?.cutOff
                      ? "Passed"
                      : "Failed"
                    : candidateAssessmentDetails?.currentStatus,
                ).bg,

                borderRadius: "5px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "20px",
                  color: getColorByStatus(
                    candidateAssessmentDetails?.currentStatus === "Appeared"
                      ? candidateAssessmentDetails?.assessmentResult
                          ?.totalObtainedScore >=
                        candidateAssessmentDetails?.assessmentId?.cutOff
                        ? "Passed"
                        : "Failed"
                      : candidateAssessmentDetails?.currentStatus,
                  ).color,
                  textWrap: "nowrap",
                }}
              >
                {candidateAssessmentDetails?.currentStatus === "Appeared"
                  ? candidateAssessmentDetails?.assessmentResult
                      .totalObtainedScore >=
                    candidateAssessmentDetails?.assessmentId?.cutOff
                    ? "Passed"
                    : "Failed"
                  : candidateAssessmentDetails?.currentStatus}{" "}
              </Typography>
            </Stack>
          </Box>

          <Box>
            {candidate_details_profile.map((elem, index) => (
              <Stack
                key={index}
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"flex-end"}
                sx={{ borderBottom: "1px solid #E8E9EE" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    padding: "16px 0px",
                  }}
                >
                  <Box>
                    <img src={elem.icn} alt={elem.lable} />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "Roboto",
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "16px",
                        color: "#535A5F",
                      }}
                    >
                      {elem.lable}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Nunito",
                        fontWeight: "700",
                        fontSize: "24px",
                        lineHeight: "32px",
                        color: "#333333",
                      }}
                    >
                      {elem.number}
                    </Typography>
                  </Box>
                </Box>
                {(elem.lable === "Snapshots Taken" ||
                  elem.lable === "Tabs switched" ||
                  elem.lable === "Plagiarism (%)") && (
                  <Button
                    size="small"
                    variant="text"
                    color="secondary"
                    onClick={() => handleButtonClick(elem.lable)}
                    sx={{
                      fontFamily: "Roboto",
                      fontWeight: 400,
                      fontSize: "14px",
                      lineHeight: "20px",
                      padding: "0",
                      margin: "16px 0px",
                    }}
                  >
                    {elem.lable === "Snapshots Taken" && "View Snapshot"}
                    {elem.lable === "Tabs switched" && "View Tabs"}
                    {elem.lable === "Plagiarism (%)" && "View Details"}
                  </Button>
                )}
              </Stack>
            ))}
          </Box>
        </Box>
        <Box
          sx={{
            width: { xss: "50%", md: "70%" },
            backgroundColor: "",
            overflowY: "auto",
            maxHeight: "100%",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              gap: "16px",
              flexDirection: { md: "row", base: "column" },
              height: { md: "auto", xss: "100%" },
            }}
          >
            <Box
              sx={{
                width: { md: "50%", xss: "100%" },
                backgroundColor: "#ffffff",
                padding: "16px",
                borderRadius: "4px",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: "18px",
                  fontWeight: "700",
                  fontFamily: "Nunito, sans-serif",
                }}
              >
                About
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: { md: "10px", base: "0px" },
                  flexDirection: { md: "row", base: "column" },
                }}
              >
                <Box sx={{ width: { md: "50%", xss: "100%" } }}>
                  {candidate_details_about
                    .filter((_, index) => index % 2 === 0)
                    .map((elem, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          width: "100%",
                          marginTop: "16px",
                        }}
                      >
                        {elem.icn}
                        <Typography
                          sx={{
                            maxWidth: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "14px",
                            whiteSpace: "nowrap",
                            cursor: "pointer",
                          }}
                          onClick={(e) => handlePopoverOpen(e, elem.label)}
                        >
                          {elem.label}
                        </Typography>
                      </Box>
                    ))}
                </Box>

                <Box sx={{ width: { md: "50%", xss: "100%" } }}>
                  {candidate_details_about
                    .filter((_, index) => index % 2 !== 0)
                    .map((elem, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          width: "100%",
                          marginTop: "16px",
                        }}
                      >
                        {elem.icn}
                        <Typography
                          sx={{
                            maxWidth: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "14px",
                            whiteSpace: "nowrap",
                            cursor: "pointer",
                          }}
                          onClick={(e) => handlePopoverOpen(e, elem.label)}
                        >
                          {elem.label}
                        </Typography>
                      </Box>
                    ))}
                </Box>

                <Popover
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handlePopoverClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <Box sx={{ p: 2 }}>
                    <Typography variant="body1">{popoverText}</Typography>
                  </Box>
                </Popover>
              </Box>
            </Box>
            <Box
              sx={{
                width: { md: "50%", xss: "100%" },
                backgroundColor: "#ffffff",
                padding: "16px",
                borderRadius: "4px",
                height: { md: "auto", xss: "100%" },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: "18px",
                  fontWeight: "700",
                  fontFamily: "Nunito, sans-serif",
                }}
              >
                Test Time Analysis
              </Typography>
              <Box
                sx={{
                  marginTop: "16px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                {candidate_pool_test_time_analysis.map((elem, index) => (
                  <Box key={index}>
                    <Typography
                      sx={{
                        fontFamily: "Roboto",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "#535A5F",
                      }}
                    >
                      {elem.lable}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Roboto",
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#363E45",
                      }}
                    >
                      {elem.time}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              border: "1px solid #EBEBEB",
              borderRadius: "4px",
              width: "100%",
              boxShadow: "0px 0px 4px 0px #0000001A",
              bgcolor: "#fff",
              marginTop: "16px",
            }}
          >
            <SkillWisePerformance
              skillData={
                candidateAssessmentDetails?.assessmentResult?.testQuestions
                  ?.skills
              }
            />
          </Box>

          <Box
            sx={{
              width: "100%",
              padding: "16px",
              marginTop: "16px",
              backgroundColor: "#ffffff",
              display: { md: "block", base: "none" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: "18px",
                  fontWeight: "700",
                  fontFamily: "Nunito, sans-serif",
                }}
              >
                Question Report
              </Typography>
              <FormControl sx={{ m: 1, minWidth: 120 }}>
                <Select
                  value={selectedOption}
                  onChange={handleChange}
                  displayEmpty={false}
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #E8E9EE",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #E8E9EE",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #E8E9EE",
                    },
                    height: "34px",
                  }}
                >
                  <MenuItem value="mcqQuestions">MCQ Questions</MenuItem>
                  <MenuItem value="programmingQuestions">
                    Programming Questions
                  </MenuItem>
                  <MenuItem value="sqlQuestions">SQL Questions</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ marginTop: "16px" }}>
              <QuationReportTable
                data={
                  candidateAssessmentDetails?.assessmentResult?.testQuestions
                }
                selectedOption={selectedOption}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <CheatingDetected
        open={toggleDrawer}
        setOpen={setToggleDrawer}
        currentTab={currentTab}
        drawerHeading={drawerHeading}
        data={candidateAssessmentDetails}
      />
      {/* <Box
        sx={{
          width: "100%",
          padding: "16px",
          marginTop: "16px",
          backgroundColor: "#ffffff",
          display: { md: "none", base: "block" },
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: "18px",
            fontWeight: "700",
            fontFamily: "Nunito, sans-serif",
          }}
        >
          Check Skill-wise Performance
        </Typography>
        <Box>
          <CandidateResultsDataTable
            data={candidateAssessmentDetails?.assessmentResult?.testQuestions}
          />
        </Box>
      </Box> */}
      <Box
        sx={{
          width: "100%",
          padding: "16px",
          marginTop: "16px",
          backgroundColor: "#ffffff",
          display: { md: "none", base: "block" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: "18px",
              fontWeight: "700",
              fontFamily: "Nunito, sans-serif",
            }}
          >
            Question Report
          </Typography>
          <FormControl sx={{ m: 1, minWidth: 120 }}>
            <Select
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "2px solid #E8E9EE", // Change border color
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: "2px solid #E8E9EE", // Change border color on hover
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "2px solid #E8E9EE", // Change border color when focused
                },
                height: "34px",
              }}
            >
              <MenuItem value="MCQ Questions">MCQ Questions</MenuItem>
              <MenuItem value="Programming Questions">
                Programming Questions
              </MenuItem>
              <MenuItem value="SQL Questions">SQL Questions</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ marginTop: "16px" }}>
          <QuationReportTable
            data={candidateAssessmentDetails?.assessmentResult?.testQuestions}
            selectedOption={selectedOption}
          />
        </Box>
      </Box>
    </>
  );
};

export default CandidateResults;
